export const About = () => {
  return (
    <div>
      <p>
        Sheepshead Bay Animal Rescue is a group of volunteers who are committed to helping cats in need. Our work
        includes everything from animal rescue to trap-neuter-return ("TNR").
      </p>
      <p>
        We nurse injured and sick animals back to health, find homes for friendly cats and help provide for cats who are
        better off living outdoors. We’ve been working as a team since 2016 and have been able to TNR and rehabilitate
        hundreds of kittens and cats. We maintain colonies in several parts of Brooklyn and help countless animals in
        need around the city every day. We also work with communities across Brooklyn to raise the level of awareness of
        animal welfare with outreach and education
      </p>
    </div>
  );
};
